<template>
  <div>
    <material-card
      icon="share"
      :color="$vuetify.theme.themes.light.secondary"
      :loading="loading"
      :title="$t('sharememberfiles.share_files')"
    >
      <v-card-text>
        <v-container fluid>
          <v-form v-model="valid" ref="form">
            <v-row>
              <v-col>
                <v-combobox
                  prepend-icon="email"
                  ref="mailSearchCombo"
                  background-color="grey lighten-1"
                  persistent-placeholder
                  :placeholder="$t('sharememberfiles.share_email')"
                  v-model="selected"
                  :loading="loading"
                  :items="usersOrMembers"
                  :search-input.sync="search"
                  multiple
                  hide-no-data
                  solo-inverted
                  chips
                  deletable-chips
                  :rules="[$rules.atLeastOne, rules.email]"
                  flat
                  no-filter
                >
                  <v-list-item slot="prepend-item">
                    <v-btn text @click="closeMenu" small>
                      {{ $t("globals.close") }}
                    </v-btn>
                  </v-list-item>
                  <template
                    v-slot:selection="{
                      attrs,
                      item,
                      parent,
                      selected,
                    }"
                  >
                    <v-chip
                      v-if="item === Object(item)"
                      v-bind="attrs"
                      :input-value="selected"
                      label
                      small
                      light
                    >
                      <span class="pr-2">
                        {{ item.value }}
                      </span>
                      <v-icon small @click="parent.selectItem(item)">
                        $delete
                      </v-icon>
                    </v-chip>
                  </template>
                  <!-- <template v-slot:item="{
                      item,
                    }">
                    <div v-if="item.header" class="v-subheader theme--light">{{item.header}}</div>
                    <hr v-else-if="item.divider" role="separator" aria-orientation="horizontal" class="v-divider theme--light"/>
                    <v-list-item-content v-else>
                      <v-list-item-title
                        v-html="item.text"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </template> -->
                </v-combobox>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <pbas-date-picker
                  :value="payload.ExpirationDate"
                  @update-date="payload.ExpirationDate = $event"
                  :label="$t('sharememberfiles.expiration_date')"
                  :allowedDates="notBeforeTomorrow"
                ></pbas-date-picker>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <trans-select
                  :item="payload"
                  propertyName="LanguageChoice"
                  :items="columnsDropDownOptions.Models.LanguageChoice"
                  :label="$t('headers.members_management.LanguageChoice')"
                  class="required"
                  :rules="[$rules.required]"
                ></trans-select>
              </v-col>
              <!-- <v-col>
                <v-checkbox
                  v-model="payload.ShouldBeSent"
                  :label="$t('sharememberfiles.send_mail')"
                ></v-checkbox>
              </v-col> -->
            </v-row>
          </v-form>
          <v-row v-if="shareLink">
            <v-col
              cols="3"
              class="d-flex justify-center pa-0 pl-4 text-body-1"
              align-self="center"
            >
              {{ $t("sharememberfiles.text_copy") }}
            </v-col>
            <v-col class="pa-0 pr-9">
              <v-text-field
                class="text-body-2"
                readonly
                :append-icon="'mdi-content-copy'"
                v-model="shareLink"
                ref="textToCopy"
                @click:append="copyText"
              />
            </v-col>
          </v-row>
          <v-row dense flat color="white" v-show="showGuestWarning">
            <v-col class="red--text text-center pa-0">
              {{ $t("sharememberfiles.share_warning") }}
            </v-col>
          </v-row>
          <v-row dense flat color="white" v-show="confirmationMessageB">
            <v-col class="green--text text-center pa-0">
              {{ confirmationMessage }}
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-btn text @click="closeDialog">
          {{ success ? $t("globals.close") : $t("globals.cancel") }}
        </v-btn>
        <v-btn
          color="warning"
          @click="clear"
          v-if="!success"
          :disabled="selected.length === 0"
        >
          {{ $t("globals.clear") }}
        </v-btn>
        <v-btn
          color="primary"
          @click="tryShareFiles"
          v-if="!success"
          :disabled="
            ($refs.mailSearchCombo && $refs.mailSearchCombo.isMenuActive) ||
              !valid
          "
          :loading="saving"
        >
          {{ $t("sharememberfiles.share_files") }}
        </v-btn>
      </v-card-actions>
      <error-handler :error="error"></error-handler>
    </material-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import { mapFileSegmentIds } from "../makeMemberFile";
import TransSelect from "../components/TransSelect.vue";

export default {
  name: "share-member-files",
  props: {
    fileIds: Array,
    files: Array,
    planId: String,
    brokerId: String,
    maxDataRetrieved: Number,
  },
  components: {
    ErrorHandler,
    TransSelect,
  },
  emits: ["close-dialog"],
  computed: {
    ...mapGetters("plansMembers", {
      columnsDropDownOptions: "options",
    }),
  },
  mounted() {
    let date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000);
    this.payload.ExpirationDate = this.addDays(date, 1)
      .toISOString()
      .substr(0, 10);
  },
  data() {
    return {
      rules: {
        email: (v) => {
          console.log(v);
          if (v.length === 0) {
            return true;
          }
          let res = true;
          for (const email of v) {
            res = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              String(email.value).toLowerCase()
            );
            if (!res) {
              return this.$t("validation.email_must_be_valid");
            }
          }
          return true;
        },
      },
      valid: false,
      error: null,
      saving: false,
      loading: false,
      usersOrMembers: [],
      search: null,
      selected: [],
      shareLink: "",
      menu: false,
      modal: false,
      menu2: false,
      showGuestWarning: false,
      appearMessage: false,
      appearCheckbox: false,
      confirmationMessage: "",
      confirmationMessageB: false,
      success: false,
      payload: {
        LanguageChoice: null,
        ShouldBeSent: true,
        ExpirationDate: null,
      },
    };
  },
  watch: {
    selected(val, prev) {
      if (prev !== null) {
        if (val.length === prev.length) return;
      }
      console.log(val, prev, this.$refs.mailSearchCombo.$refs);
      this.search = null;
      this.selected = val.map((v) => {
        if (typeof v === "string") {
          let found = false;
          for (let item of this.usersOrMembers) {
            if (item.value === v) {
              found = true;
              v = item;
              break;
            }
          }
          if (!found) {
            v = {
              text: v,
              value: v,
            };
          }
        }
        return v;
      });
    },

    search(val) {
      console.log("search: ", val, this.selected);
      val && val !== this.selected && this.querySelections(val);
    },
  },
  methods: {
    ...mapActions("documentsService", ["shareFiles"]),
    ...mapActions("plansMembers", ["filterEmails"]),
    addDays(date, days) {
      var result = new Date(date);
      result.setUTCDate(result.getUTCDate() + days);
      return result;
    },
    notBeforeTomorrow(val) {
      const n = Date.parse(val);
      const d = new Date(n);
      const d2 = new Date();
      return d >= d2;
    },
    closeMenu() {
      this.$refs.mailSearchCombo.isMenuActive = false;
      console.log(this.$refs.mailSearchCombo);
    },
    async querySelections(v) {
      this.loading = true;
      const options = {
        brokerId: this.brokerId,
        planId: this.planId,
        maxDataRetrieved: this.maxDataRetrieved,
        filter: v,
      };
      try {
        let response = await this.filterEmails(options);
        let typesDictionary = {};
        this.usersOrMembers = [];
        this.$forceUpdate();
        let usersOrMembers = [];
        let data = response.data.value.sort((a, b) => {
          if (a.Type < b.Type) {
            return -1;
          } else if (a.Type === b.Type) {
            return 0;
          } else {
            return 1;
          }
        });
        for (var i of data) {
          if (Object.keys(typesDictionary).indexOf(i.Type) === -1) {
            if (Object.keys(typesDictionary).length > 0) {
              usersOrMembers.push({
                divider: true,
              });
            }
            typesDictionary[i.Type] = [];
            usersOrMembers.push({
              header: i.Type,
            });
          }
          var name =
            i.FirstName != "" ? i.FirstName + " " + i.LastName : i.LastName;
          const item = {
            text: name + " " + i.Email,
            value: i.Email,
            name: i.FirstName,
            isUser: i.Type === "Admin",
            type: i.Type,
          };
          usersOrMembers.push(item);
          typesDictionary[i.Type].push(item);
        }
        this.usersOrMembers = usersOrMembers;
        console.log(JSON.stringify(this.usersOrMembers));
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    closeDialog() {
      this.clear();
      this.$emit("closeDialog", false);
    },
    async tryShareFiles() {
      for (let receiver of this.selected) {
        if (receiver.value === receiver.text && !this.showGuestWarning) {
          this.showGuestWarning = true;
          return;
        }
      }
      this.saving = true;
      const receivers = [];
      for (let receiver of this.selected) {
        receivers.push({
          Email: receiver.value,
          Name:
            receiver.name !== null && receiver.name !== undefined
              ? receiver.name
              : receiver.value,
          IsGuest: receiver.isUser !== true,
        });
      }
      try {
        let data = JSON.parse(JSON.stringify(this.payload));
        data.FileIds =
          this.fileIds !== null && this.fileIds !== undefined
            ? this.fileIds
            : mapFileSegmentIds(this.files);
        data.Receivers = receivers;
        if (data.LanguageChoice) {
          data.Language = data.LanguageChoice.Name;
          delete data.LanguageChoice;
        }
        data.ShouldBeSent = true;
        const response = await this.shareFiles(data);
        if (response.data.length !== 0) {
          const parts = [response.data.Address];
          if (response.data.Token.length > 0) {
            parts.push(response.data.Token[0].FileName);
          }
          // this.shareLink = parts.join("");
        }
        if (response.statusText === "OK") {
          this.confirmationMessage = this.$t(
            "sharememberfiles.share_success_message"
          );
          this.success = true;
        } else {
          this.confirmationMessage = this.$t(
            "sharememberfiles.share_error_message"
          );
        }
      } catch (error) {
        this.error = error;
      } finally {
        this.dialog = false;
        this.showGuestWarning = false;
        this.confirmationMessageB = true;
        this.saving = false;
      }
    },
    copyText() {
      let textToCopy = this.$refs.textToCopy.$el.querySelector("input");
      textToCopy.select();
      document.execCommand("copy");
    },
    clear() {
      this.loading = false;
      this.usersOrMembers = [];
      this.search = null;
      this.selected = [];
      this.states = [];
      this.shareLink = "";
      this.menu = false;
      this.modal = false;
      this.menu2 = false;
      this.showGuestWarning = false;
      this.appearMessage = false;
      this.payload = {
        LanguageChoice: null,
        ShouldBeSent: false,
        ExpirationDate: new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10),
      };
      this.appearCheckbox = false;
      this.confirmationMessage = "";
      this.confirmationMessageB = false;
      this.success = false;
      this.$refs.form.resetValidation();
    },
  },
};
</script>

<style>
.padding-bottom-5 {
  padding-bottom: 5px;
}
.padding-top-1 {
  padding-top: 1px;
}
</style>
